import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { listSiteInfoObsrec } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';

const list = () => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    const result = await listSiteInfoObsrec();
    dispatch(actions.list.done({ params: {}, result: { Items: result } }));
  } catch (error) {
    dispatch(actions.list.failed({ params: {}, error: error.toString() }))
    getLogger().error('siteInfoListObsrec/list()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

const clear = () => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(actions.clear());
};

export {
  list,
  clear
};



// WEBPACK FOOTER //
// ./src/redux/modules/siteInfoListObsrec/operations.ts